import React from 'react';
import { motion } from 'framer-motion';

const Hero: React.FC = () => {
  return (
    <section id="hero" className="min-h-screen flex flex-col justify-center bg-[#050505] px-6 sm:px-12 pt-28 pb-12 font-sans relative overflow-hidden">
      {/* Background grid */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#18181b_1px,transparent_1px),linear-gradient(to_bottom,#18181b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-20"></div>

      <div className="max-w-6xl w-full mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex flex-col gap-5 sm:gap-6"
        >
          {/* Status Indicator */}
          <div className="flex items-start sm:items-center gap-3 font-mono text-[10px] sm:text-xs tracking-widest text-zinc-400 uppercase pr-10 sm:pr-0">
            <span className="relative flex h-2 w-2 mt-1 sm:mt-0 flex-shrink-0">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
            </span>
<span className="leading-relaxed">Based in UAE // Available for Opportunities</span>          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-7xl md:text-8xl font-black text-white tracking-tighter uppercase leading-[0.9] mt-2">
            Muhammed <br className="hidden sm:block" />
            <span className="text-zinc-500">Sufiyan PK</span>
          </h1>

          {/* Terminal Box */}
          <div className="font-mono text-xs sm:text-base md:text-lg text-zinc-300 max-w-2xl mt-4 border-l-2 border-zinc-700 pl-4 bg-zinc-900/30 sm:bg-transparent p-3 sm:p-0">
            <p className="mb-2 text-zinc-500">root@sufiyan:~# cat profile.sh</p>
            <p className="text-white font-bold sm:font-normal">DEVSECOPS & AI INFRASTRUCTURE ENGINEER.</p>
            <p className="text-zinc-400 mt-2 text-[11px] sm:text-sm leading-relaxed">
              6+ years designing, securing, and operating HPC infrastructure. Specialized in NVIDIA GPU scheduling, VMware Tanzu, and bare-metal Kubernetes. Executing GitOps transformations and zero-trust security models for enterprise and government workloads.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mt-6 sm:mt-8">
            <button 
              onClick={() => document.getElementById('experience')?.scrollIntoView({ behavior: 'smooth' })}
              className="w-full sm:w-auto bg-white text-black font-mono text-xs uppercase tracking-widest px-6 py-4 hover:bg-zinc-200 transition-colors text-center"
            >
              Execute ./Experience.sh
            </button>
            <button 
              onClick={() => window.open('https://www.linkedin.com/in/sufiyanpk/', '_blank')}
              className="w-full sm:w-auto bg-transparent text-white border border-zinc-700 font-mono text-xs uppercase tracking-widest px-6 py-4 hover:border-white transition-colors text-center"
            >
              Initialize Contact
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;